<template>
    <div class="container">
        <div class="col-md-12 mt-3">
            <h2> {{ labels.title }} </h2>
        </div>
        <div class="row mt-5">
            <div class="col-md-6 d-flex justify-content-end">
                <h4>{{ labels.fecha }}</h4>
            </div>
            <div class="col-md-2 d-flex justify-content-start">
                <select v-model="fecha" class="form-control">
                    <option value="">{{ labels.seleccion }}</option>
                    <option v-for="item in lstFechaCausacion" :key="item.id" :value="item.vigencia"> {{ item.vigencia }} </option>
                </select>
            </div>
        </div>
        <div class="col-md-12 mt-4">
            <b-button type="button" id="create-btn" @click="consultaSaldos">{{ labels.consultar }}</b-button>
        </div>
        <b-row v-if="loading" class="justify-content-center mt-5">
            <b-spinner
                label="Cargando..."
                variant="primary"
                style="width: 3rem; height: 3rem;"
            ></b-spinner>
        </b-row>
        <b-row class="d-flex justify-content-center col-12 mt-2" v-if="!loading && lstCausacion.length != 0">
            <div v-if="btnGenExcel" class="row col-md-12 d-flex justify-content-end">
                <md-button style="background-color: #2e507a; width: 40px; height: 40px;" class="md-fab md-primary" @click="genExcelListadoCausacion()">
                    <md-icon>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path fill="#ffffff" d="M192 112L304 112L304 200C304 239.8 336.2 272 376 272L464 272L464 512C464 520.8 456.8 528 448 528L192 528C183.2 528 176 520.8 176 512L176 128C176 119.2 183.2 112 192 112zM352 131.9L444.1 224L376 224C362.7 224 352 213.3 352 200L352 131.9zM192 64C156.7 64 128 92.7 128 128L128 512C128 547.3 156.7 576 192 576L448 576C483.3 576 512 547.3 512 512L512 250.5C512 233.5 505.3 217.2 493.3 205.2L370.7 82.7C358.7 70.7 342.5 64 325.5 64L192 64zM291.2 329.6C283.2 319 268.2 316.8 257.6 324.8C247 332.8 244.8 347.8 252.8 358.4L290 408L252.8 457.6C244.8 468.2 247 483.2 257.6 491.2C268.2 499.2 283.2 497 291.2 486.4L320 448L348.8 486.4C356.8 497 371.8 499.2 382.4 491.2C393 483.2 395.2 468.2 387.2 457.6L350 408L387.2 358.4C395.2 347.8 393 332.8 382.4 324.8C371.8 316.8 356.8 319 348.8 329.6L320 368L291.2 329.6z"/></svg>
                    </md-icon>
                </md-button>
            </div>
            <b-table
                :items="lstCausacion"
                :fields="fields"
                hover
                bordered
                responsive
                sticky-header="500px"
                small
                class="tblEstandar"
                head-variant="custom-blue"
                :per-page="perPage"
                :current-page="currentPage"
            >
                <template #cell(saldo_anterior)="data">
                    <div class="text-right">{{ formatNumber(data.item.saldo_anterior) }}</div>
                </template>
                <template #cell(debito)="data">
                    <div class="text-right">{{ formatNumber(data.item.debito) }}</div>
                </template>
                <template #cell(credito)="data">
                    <div class="text-right">{{ formatNumber(data.item.credito) }}</div>
                </template>
                <template #cell(saldo_actual)="data">
                    <div class="text-right">{{ formatNumber(data.item.saldo_actual) }}</div>
                </template>
            </b-table>
            <div class="row col-12 mt-1">
                <div class="col-10 d-flex justify-content-center">
                    <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="lstCausacion.length"
                    align="center"
                    size="md"
                    class="custom-pagination"
                    ></b-pagination>
                </div>
                <div class="col-2 d-flex justify-content-end">
                    <label class="mr-2 mb-0">Filas por página:</label>
                    <b-form-select
                    v-model="perPage"
                    :options="[5, 10, 20, 50, 100, 500]"
                    size="sm"
                    style="width: 80px;"
                    ></b-form-select>
                </div>
            </div>
        </b-row>
    </div>
</template>

<script>
import ContratoSaldos from '../../services/ContratoSaldos';
import Authentication from '../../services/Authentication';
import * as XLSX from "exceljs";

export default {
    name : 'ListadoCausacion',
    data : () => ({
        fecha : '',
        btnGenExcel : false,
        loading: false,
        lstFechaCausacion : [],
        lstCausacion : [],
        nameCompania : '',
        perPage: 500,
        currentPage: 1,
        fields: [
            { key: 'nro_contrato', label: 'Contrato', sortable: false },
            { key: 'identificacion', label: 'Proveedor', sortable: false },
            { key: 'tipo_activo', label: 'Tipo activo', sortable: false },
            { key: 'cuenta', label: 'Nro. cuenta', sortable: false },
            { key: 'nombre', label: 'Cuenta', sortable: false },
            { key: 'centro_costo', label: 'Centro costo', sortable: false },
            { key: 'saldo_anterior', label: 'Saldo anterior', sortable: false },
            { key: 'debito', label: 'Débito', sortable: false },
            { key: 'credito', label: 'Crédito', sortable: false },
            { key: 'saldo_actual', label: 'Saldo actual', sortable: false },
        ],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Listado causación',
                    seleccion : 'Seleccione...',
                    fecha : 'Fecha:',
                    consultar : 'Consultar',
                    noRow : 'No hay registros.',
                }
            }else{
                return {
                    title : 'Causation list',
                    seleccion : 'Select...',
                    fecha : 'Date:',
                    consultar : 'Consult',
                    noRow : 'There are no records.',
                }
            }
        }
    },
    methods:{
        consultaSaldos(){
            
            if (this.fecha == '') {
                this.lstCausacion = []
                this.$toast.error('Diligenciar la fecha.');
                return;
            }

            this.loading = true

            ContratoSaldos.consultaListadoCausacion(this.fecha)
            .then((res) => {
                // console.log(res.data);
                this.lstCausacion = res.data.infoCausacion
                this.btnGenExcel = true
            }).catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.loading = false
            });
        },
        async genExcelListadoCausacion(){

            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Listado causacion "+this.fecha)

            const titulo = ["Listado causacion - "+this.fecha]
            worksheet.addRow(titulo)
            worksheet.mergeCells('A1:J1')
            worksheet.getCell('A1').font = { name: 'Arial', bold : true, size : 12};
            worksheet.getCell('A1').alignment = { horizontal : 'center'};

            // =======================
            // FILA 2
            // =======================
            worksheet.addRow(['']);
            worksheet.mergeCells('A2:J2');

            const cell2 = worksheet.getCell('A2');

            cell2.value = {
                richText: [
                    { text: 'Generado por: ', font: { bold: true } },
                    { text: `${this.$store.state.userName} | ` },

                    { text: 'Fecha generación: ', font: { bold: true } },
                    { text: `${this.fechaActual()} | ` },

                    { text: 'Compañía: ', font: { bold: true } },
                    { text: `${this.nameCompania}` },
                ]
            };

            cell2.font = { name: 'Arial', size: 12 };
            cell2.alignment = { horizontal: 'center', vertical: 'middle' };

            worksheet.addRow(['']);
            worksheet.mergeCells('A3:J3')

            // =======================
            // HEADER TABLA
            // =======================
            const headerRow = worksheet.addRow([
                'Contrato',
                'Proveedor',
                'Tipo activo',
                'Nro. cuenta',
                'Cuenta',
                'Centro costo',
                'Saldo anterior',
                'Debito',
                'Credito',
                'Saldo actual'
            ])

            headerRow.font = { name: 'Arial', size: 11, bold: true }
            headerRow.alignment = { horizontal: 'center' }

            // =======================
            // DATA
            // =======================
            this.lstCausacion.forEach(e => {
                worksheet.addRow([
                    e.nro_contrato,
                    e.identificacion,
                    e.tipo_activo,
                    e.cuenta,
                    e.nombre,
                    e.centro_costo,
                    this.formatNumber(e.saldo_anterior),
                    this.formatNumber(e.debito),
                    this.formatNumber(e.credito),
                    this.formatNumber(e.saldo_actual)
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }
            
            for( let row = 1; row <= worksheet.rowCount; row++){

                if ([1, 2, 3].includes(row)) continue; // 👈 omitir filas

                for( let col = 1; col <= worksheet.columnCount; col++){
                    worksheet.getCell(row, col).border = border;
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer()
            const downloadLink = document.createElement("a")
            downloadLink.download = "Listado causación "+this.fecha+".xlsx"
            downloadLink.href = window.URL.createObjectURL(
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                })
            )

            downloadLink.style.display = "none";

            document.body.appendChild(downloadLink);
            downloadLink.click();

            downloadLink.remove();
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
        },
        fechaActual(){
            const fecha = new Date()

            const año = fecha.getFullYear()
            const mes = String(fecha.getMonth() + 1).padStart(2, '0') // getMonth() va de 0 a 11
            const dia = String(fecha.getDate()).padStart(2, '0')

            return `${año}-${mes}-${dia}`
        },
    },
    mounted(){

        ContratoSaldos.getListadoFechas()
        .then((res) => {
            // console.log(res.data.lstFechaSaldo);
            this.lstFechaCausacion = res.data.lstFechaSaldo
        })
        .catch((err) => console.log(err))

        Authentication.leaParametros()
        .then ((result) => {
            this.nameCompania = result.data.parametros.compania
        })
        .catch((err) => console.log(err))
    }
}
</script>

<style>

</style>